import { render, staticRenderFns } from "./EventoRoute.vue?vue&type=template&id=3bbe7476"
import script from "./EventoRoute.vue?vue&type=script&lang=js"
export * from "./EventoRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports